import { reducedMotion } from '../lib/motion';

/**
 * Opening a lesson: the tapped photograph leans in a touch while the page dissolves — an editorial
 * page turn, not a 3D flight. Pure WAAPI; resolves when the page has faded so the router can switch.
 */
export async function liftCardIntoPlayer(card: HTMLElement): Promise<void> {
  const page = document.querySelector('.page');
  if (reducedMotion()) {
    page?.classList.add('is-sinking');
    await new Promise((r) => setTimeout(r, 120));
    return;
  }
  const img = card.querySelector<HTMLElement>('img');
  img?.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.045)' }], { duration: 320, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'forwards' });
  page?.classList.add('is-sinking');
  await new Promise((r) => setTimeout(r, 260));
}
